import { gql } from '@apollo/client';

export const DELETE_ROOM = gql`
  mutation DeleteRoom($record: DeleteRoomInput!) {
    schedule {
      deleteRoom(record: $record) {
        ok
        error {
          message
          code
        }
      }
    }
  }
`;
